export * from './platform.module';
export * from './platform.service';
